<script lang="ts">
  import NoOrderActionBar from "@retailer/svelte/ProductLines/NoOrderActionBar.svelte";
  import OrderActionBar from "@retailer/svelte/ProductLines/OrderActionBar.svelte";
  import { default as CraftNavigation } from "@modern/components/retailer/Navigation/ProductLinesNavigation.svelte";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import DiscoveryPanel from "@shared/svelte/DiscoveryPanel/DiscoveryPanel.svelte";
  import PageTitle from "@shared/svelte/Components/PageTitle.svelte";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import ProductListingResults from "@retailer/svelte/ProductLines/ProductLineContainer/ProductListingResults.svelte";

  import type { ProductIndexBanner } from "@shared/types/ProductIndexBanner";
  import type { RetailerType } from "@shared/types/Retailer";
  import type { RetailerUser } from "@shared/types/User";

  export let discoveryPanelRes: any;
  export let productIndexBannersRes: ProductIndexBanner[];
  export let retailer: RetailerType;
  export let stateParams: any;

  export let Distributors: any;

  let user: RetailerUser = $CurrentUserStore as RetailerUser;

  let discoveryPanelConfig = discoveryPanelRes || [];
  const hasOrdered = !!retailer?.last_ordered_at;
</script>

<PageTitle title="Provi | Home" />
<CraftNavigation />
<PageWrapper let:mobileMode>
  {#if retailer && hasOrdered}
    <OrderActionBar {user} {retailer} />
  {:else if retailer}
    <NoOrderActionBar {Distributors} {user} />
  {/if}

  <DiscoveryPanel
    carouselCardsShown={5}
    configuration={discoveryPanelConfig}
    pageName={"home"}
    {mobileMode}
    {stateParams}
  />

  <div class="fizz-inset-horizontal-32">
    <ProductListingResults {mobileMode} {stateParams} bind:productIndexBannersRes isHome={true} />
  </div>
</PageWrapper>
